import { isProd } from '../config/config';

const REACT_APP_USER_FLOW_PROD_TOKEN = 'ct_r5jjyq4v5nhy7oaqksyoin3tfi';
const REACT_APP_USER_FLOW_DEV_TOKEN = 'ct_srmrec6pfvfk5cpzllzek463ii';
export const USER_FLOW_TOKEN = isProd
  ? REACT_APP_USER_FLOW_PROD_TOKEN
  : REACT_APP_USER_FLOW_DEV_TOKEN;
